export default __webpack_public_path__ + "static/media/fees.70814228.jpg";